import _findInstanceProperty from "@babel/runtime-corejs3/core-js/instance/find";
import { computed, defineComponent, nextTick, ref, watch } from "@vue/composition-api";
import { useSummaryHelpers } from "@Client/@Composables/application-standalone/pages/summary/useSummaryHelpers";
import { useApplicationStandaloneStoreActions, useApplicationStandaloneStoreGetters } from "@Client/@Modules/application-standalone/store/application-standalone-helpers";
import * as ApplicationStandaloneGetters from "@Client/@Modules/application-standalone/store/application-standalone-getters";
import { useI18n } from "vue-i18n-composable";
import * as ApplicationStandAloneActions from "@Client/@Modules/application-standalone/store/application-standalone-actions";
import InlineLoader from "@Shared/components/general/inline-loader.vue";
export default defineComponent({
  name: "DisclaimersSection",
  components: {
    InlineLoader
  },
  setup(props, {
    emit
  }) {
    const loadingDisclaimers = ref(false);
    const {
      disclaimers,
      updateAcceptedConsents,
      isConsentsAcceptedValid
    } = useSummaryHelpers();
    const {
      locale
    } = useI18n();
    const {
      LOAD_DISCLAIMERS
    } = useApplicationStandaloneStoreActions([ApplicationStandAloneActions.LOAD_DISCLAIMERS]);
    watch(isConsentsAcceptedValid, newValue => emit("is-valid", newValue), {
      immediate: true
    });
    const {
      GET_ACCEPTED_CONSENTS
    } = useApplicationStandaloneStoreGetters([ApplicationStandaloneGetters.GET_ACCEPTED_CONSENTS]);
    const isAccepted = consentId => {
      var _context;
      return _findInstanceProperty(_context = GET_ACCEPTED_CONSENTS.value).call(_context, consent => consent.id === consentId);
    };
    const isFrenchLanguage = computed(() => {
      return locale.value === "fr-CA";
    });
    const handleDownloadConsent = async index => {
      var _disclaimers$value$in, _disclaimers$value, _disclaimers$value$in2;
      loadingDisclaimers.value = true;
      await LOAD_DISCLAIMERS();
      await nextTick();
      const {
        url,
        fileName
      } = (_disclaimers$value$in = (_disclaimers$value = disclaimers.value) == null ? void 0 : (_disclaimers$value$in2 = _disclaimers$value[index]) == null ? void 0 : _disclaimers$value$in2["signedOptions"]) != null ? _disclaimers$value$in : {};
      const link = document.createElement("a");
      link.href = url;
      link.download = fileName;
      link.click();
      loadingDisclaimers.value = false;
    };
    return {
      disclaimers,
      updateAcceptedConsents,
      isConsentsAcceptedValid,
      isAccepted,
      isFrenchLanguage,
      handleDownloadConsent,
      loadingDisclaimers
    };
  }
});